import useWindowSize from 'components/util/useWindowSize'
import RightRobotCard from 'components/cards/new/common/RightRobotCard'

const DigitisedPostManagement = () => {
  const size = useWindowSize()
  return (
    <RightRobotCard
      image={{
        alt: 'Robot holding phone with envelopes background',
        desktop: {
          dimensions: {
            height: 558,
            width: 843,
          },
          src: '/images/new/au/robot-holding-phone-envelopsbg.png',
        },
        mobile: {
          dimensions: {
            height: 370,
            width: 559,
          },
          src: '/images/new/au/robot-holding-phone-envelopsbg.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '58%' : '100%'}
      imageStyle={{
        height: '100%',
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'left',
      }}
    >
      <div className='d-flex flex-column flex-1 px-4 pb-14 ps-lg-20 pt-25 pb-20'>
        <h2 className='fs-fluid-52 lh-105 fw-semibold mb-6'>
          Digitised Post Management
        </h2>
        <div className='fs-26 fw-semibold lh-119'>
          From our Sydney operations centre, we scan, categorise, and securely
          route incoming post using machine learning and our proprietary AI
          agent HaiRo™. Fraud detection, smart sorting, and automated
          forwarding—all handled without manual input.
        </div>
      </div>
    </RightRobotCard>
  )
}

export default DigitisedPostManagement
